import React, { Component } from "react";
import { Row, Col, Form, Select, Input, Tabs } from "antd";
import { checkNameApproves } from "../../../../../utils/leave";

const { TabPane } = Tabs;
const { Option } = Select;

class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
  };

  onChangeValueApprover = async (arrayId, values, name) => {
    const { dropdownListApprover, propFormInput } = this.props;

    let dropdownMap = dropdownListApprover[arrayId].userList;

    await dropdownMap.map((valuesDropdown, keys) => {
      if (values == valuesDropdown.empCode) {
        let tbApprover = propFormInput.getFieldValue("tbApprover");

        Object.assign(tbApprover[arrayId], {
          empName: valuesDropdown.empName,
          positionCode: valuesDropdown.positionCode,
          positionName: valuesDropdown.positionName,
          empCode: valuesDropdown.empCode,
          level: dropdownListApprover[arrayId].level,
          canEdit: dropdownListApprover[arrayId].canEdit,
          role: dropdownListApprover[arrayId].role,
        });
        propFormInput.setFieldsValue({ tbApprover });
      }
    });
  };

  render() {
    const { propFormInput, isViewOnly, rawData, dropdownListApprover } =
      this.props;
    const {} = this.state;

    console.log("dropdownListApprover", dropdownListApprover);
    console.log("rawData approver", rawData);
    return (
      <div>
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} className="">
            <strong className="color-red">เลือกผู้อนุมัติ :</strong>
          </Col>
        </Row>

        {dropdownListApprover.length > 0 && (
          <Row gutter={16} type="flex" justify="left" align="top" className="">
            {dropdownListApprover.length !== 0
              ? dropdownListApprover.map((valuseLabel, keysLabel) => {
                  return (
                    <Col xs={24} md={24} className="mt-2 pt-2">
                      <Form.Item
                        label={checkNameApproves(
                          dropdownListApprover.length,
                          parseInt(keysLabel) + 1
                        )}
                        style={{ width: "50%", marginBottom: "0px" }}
                      >
                        {propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].empCode`,
                          {
                            initialValue:valuseLabel.empCode,
                            rules: [
                              {
                                required: true,
                                message: "กรุณาเลือก ชื่อผู้อนุมัติ",
                              },
                            ],
                          }
                        )(
                          <Select
                            style={{ width: "100%" }}
                            placeholder={"กรุณาเลือก ชื่อผู้อนุมัติ"}
                            disabled={isViewOnly}
                            onChange={(value) =>
                              this.onChangeValueApprover(
                                keysLabel,
                                value,
                                "tbApprover"
                              )
                            }
                          >
                            {/* {valuseLabel.map(
                              (valueSelect, keysSelect) => {
                                return (
                                  <Option
                                    value={
                                      valueSelect.empCode
                                        ? valueSelect.empCode
                                        : "1"
                                    }
                                  >
                                    {valueSelect.empName}
                                  </Option>
                                );
                              }
                            )} */}
                            <Option
                              value={
                                 valuseLabel.empCode
                              }
                              >
                              {valuseLabel.empName}
                              </Option>
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].level`,
                          {
                            initialValue:valuseLabel.level,
                          }
                        )(<Input />)}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].empName`,
                          {
                           initialValue:valuseLabel.empName,
                          }
                        )(<Input />)}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].positionCode`,
                          {
                            initialValue:valuseLabel.positionCode,
                          }
                        )(<Input />)}
                      </Form.Item>
                      {rawData[keysLabel]?.approverId && (
                        <>
                          <Form.Item
                            label={""}
                            style={{ marginBottom: "0px" }}
                            hidden
                          >
                            {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].approverId`,
                          {
                            initialValue:
                            rawData[keysLabel]?.approverId
                          }
                        )(<Input />)}
                          </Form.Item>
                        </>
                       )} 
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].positionName`,
                          {
                           initialValue:valuseLabel.positionName,
                          }
                        )(<Input />)}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].canEdit`,
                          {
                           initialValue:valuseLabel.canEdit,
                          }
                        )(<Input />)}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].role`,
                          {
                            initialValue:valuseLabel.role,
                          }
                        )(<Input />)}
                      </Form.Item>
                      <Form.Item
                        label={""}
                        style={{ marginBottom: "0px" }}
                        hidden
                      >
                        {this.props.propFormInput.getFieldDecorator(
                          `tbApprover[${keysLabel}].status`,
                          {
                            initialValue: "pending",
                          }
                        )(<Input />)}
                      </Form.Item>

                    </Col>
                  );
                })
              : ""}
          </Row>
        )}
      </div>
    );
  }
}

export default SecProfileInformation;
